<template>
    <div>
        <div v-if="loading">
                        <div style="position: fixed; top:0; bottom:0; width:100%;background-color:#efefef;opacity:0.4;z-index:99;margin: 0 auto;text-align:center;">
            <img style="position:relative;top:45%;opacity:1;z-index:100;" src="./../../assets/images/loader.gif" alt="" />
            </div>
        </div>
        <div class="profile-sec">
        <div class="container-fluid">
            <div class="row">
                 <div class="col-md-2 zero col-xs-12">
                    <sidebar/>
                </div>
                <div class="col-md-10 col-xs-12">
                    <div class="profl-sec">
                        <div class="h3-title">
                            <h3>My Extruder Machines</h3>
                        </div>
                            <div class="profile-details" >
                                <div class="col-md-12 p_t_10">
                                    <div class="alert alert-success text-center" v-if="success!=null">
                                        {{ success }}
                                    </div>
                                    <div class="row" v-if="extruderMachines.length">
      <div class="col-md-3" v-for="(extruderMachine , index) in extruderMachines" v-bind:key="index">
        <div class="grid-item" v-if="extruderMachine">
          <div class="imgholder ">
            <a @click="viewMachine(extruderMachine.id)">
               <img :src="imgPath+extruderMachine.image1">
              <div class="top-right">
                 <div class="btn btn-warning" v-if="extruderMachine.approved=='Pending'">
                    Under Review
                </div>
                <div class="btn btn-success" v-if="extruderMachine.approved=='Approved'">
                    Published
                </div>
            </div>
            </a>
          </div>
          <div class="product_footer">
            <div class="grid_product_header">
              <span class="name">Reference ID: {{ extruderMachine.id }}<br>{{ extruderMachine.sellercompany_name }} </span>
            </div>
                <div class="product_footer-info">
                <div>{{ extruderMachine.city }} {{ extruderMachine.state }},<span v-if="extruderMachine.country">{{ extruderMachine.country.name }}</span></div>
              <div class="product-price-grid">{{ extruderMachine.spare_capacity }} Hours/Month</div>
              <div>{{ extruderMachine.machine_type }} <button class="btn btn-danger" @click="deleteMachine(extruderMachine.id)" title="Delete"><i class="fa fa-trash"></i></button></div>
            </div>
          </div>
        </div>
        <div v-else>Record Not Found</div>
      </div>
      
    </div>
    <div v-else><center><b>No Data Found</b></center></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cl"></div>
    </div>
</template>
<script>
import SideBar from './../SideBar.vue';

export default {
    components: {
        'sidebar': SideBar
    },
        
    data() {
        return {
            extruderMachines: {},
            imgPath: process.env.VUE_APP_API_URL,
            loading: false
        }
    },
    created() {
        this.loading = true
        this.axios
        .get(process.env.VUE_APP_API_URL+"api/my-extruder-machine")
        .then(response => {
            this.extruderMachines = response.data.extruder_machine;
        })
        .finally(() => this.loading = false);
    },
    methods: {
            viewMachine(id) {
              sessionStorage.setItem("MyExtruderMachine", id);
              this.$router.push({ name: "MyExtruderMachineDetails" });
            },
            deleteMachine(id) {
                this.loading = true
              this.axios
                .delete(process.env.VUE_APP_API_URL+"api/extruder-machine-delete?id="+id)
                .then(response => {
                    if(response.data.error==false){
                        window.location.reload();
                       
                    }
                     /*let i = this.extruderMacchines.map(extruderMacchine => extruderMacchine.id).indexOf(id); // find index of your object
                        this.extruderMacchines.splice(i, 1)*/
                        
                })
                .finally(() => this.loading = false);
            }
        }
};
</script>
<style type="text/css">
    .top-right {
  position: absolute;
  top: 8px;
  right: 16px;
  color: red;
  text-align: right;
}
</style>